/*
 * Usage:
 * syntax:
 * <nav oly-hover-menu oly-hover-menu-target="#sub-menu">
 *  <a oly-hover-menu-action="$ctrl.selectItem(1)" />
 *  <a oly-hover-menu-action="$ctrl.selectItem(2)" />
 * </nav>
 *
 * <div id="sub-menu">
 *  <nav ng-if="$ctrl.isSelected">
 *  </nav>
 * </div>
 * target:
 */

class HoverMenuController {
    constructor($timeout, hoverMenuService) {
        this.$timeout = $timeout;
        this.hoverMenuService = hoverMenuService;

        this.isInCone = () => false;
    }

    registerActionElement(actionElement, action) {
        if (!action) {
            return;
        }

        actionElement.on('mouseover', (event) => {
            if (this.isInCone(event.clientX, event.clientY)) {
                return;
            }

            this.isInCone = () => false;

            this.$timeout(() => {
                action({ event });
                this.isInCone = this.hoverMenuService.getHoverCone(event, this.hoverMenuElement, this.hoverMenuDir);
                const currentCone = this.isInCone;
                this.$timeout(() => {
                    if (currentCone === this.isInCone) {
                        this.isInCone = () => false;
                    }
                }, 500);
            });
        });
    }
}

module.exports = function () {
    return {
        restrict: 'A',
        controller: ['$timeout', 'HoverMenuService', HoverMenuController],
        controllerAs: '$hoverMenuController',
        link: (scope, elem, attr) => {
            scope.$hoverMenuController.hoverMenuDir = attr.olyHoverMenuDir;
            scope.$hoverMenuController.hoverMenuElement = !attr.olyHoverMenu ? elem : elem.find(attr.olyHoverMenu);

            scope.$hoverMenuController.hoverMenuElement.on('mouseleave', () => {
                scope.$hoverMenuController.isInCone = () => false;
            });
        },
    };
};



// WEBPACK FOOTER //
// ./src/olycommon/hovermenu/hovermenu.directive.js